<template>
  <div class="head-box">
    <div class="head-content">
      <div class="head-left">
        <img src="../assets/logoleft.svg" alt="" />
      </div>
      <div class="head-list">
        <div
          v-for="(v, i) in list"
          :key="i"
          :class="i == current ? 'acitve' : ''"
          @click="goSelect(i, v.linkTo)"
        >
          <a-dropdown :placement="placement" >
            <div class="ant-dropdown-link">
              <span :class="{ active: current == i }" style="color:#333333;font-size:15px">{{ v.name }}</span>
            </div>
            <template v-if="i > 0">
              <a-menu slot="overlay">
                <a-menu-item
                  v-for="(item, index) in v.children"
                  :key="index"
                  @click="go(i, item.linkTo, v.name, index)"
                >
                  <div v-if="v.children.length >= 0">
                    {{ item.name }}
                  </div>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      placement: "bottomCenter",
      current: 0,
      listSelect: false,
      list: [
        {
          name: "首页",
          linkTo: "/index?index=0",
        },
        {
          name: "关于我们",
          linkTo: "/foundation?index=1&title=关于我们&curIndex=0",
          children: [
            { name: "基金会简介", linkTo: "/foundation" },
            { name: "宗旨及使命", linkTo: "/foundation/purpose" },
            { name: "章程制度", linkTo: "/foundation/constitutionSystem" },
            { name: "组织机构", linkTo: "/foundation/organization" },
            { name: "理事会成员", linkTo: "/foundation/councilMembers" },
          ],
        },
        {
          name: "机构项目",
          linkTo: "/projects?index=2&title=机构项目&curIndex=0",
          children: [
            { name: "安全课堂", linkTo: "/projects" },
            { name: "希望助学", linkTo: "/projects/hopeStudy" },
            { name: "希望行动", linkTo: "/projects/hopeAction" },
          ],
        },
        {
          name: "信息公示",
          linkTo: "/information?index=3&title=信息公示&curIndex=0",
          children: [
            { name: "希冀月刊", linkTo: "/information" },
            { name: "希冀年报", linkTo: "/information/yearly" },
            { name: "理事会议", linkTo: "/information/meeting" },
            { name: "审计报告", linkTo: "/information/auditReport" },
            { name: "管理制度", linkTo: "/information/management" },
          ],
        },
        {
          name: "新闻中心",
          linkTo: "/newcenter?index=4&title=新闻中心&curIndex=0",
          children: [
            { name: "机构动态", linkTo: "/newcenter" },
            { name: "媒体报道", linkTo: "/newCenter/media" },
            { name: "业界资讯", linkTo: "/newCenter/industry" },
            { name: "获得荣誉", linkTo: "/newCenter/honor" },
            { name: "公益活动", linkTo: "/newCenter/activities" },
          ],
        },
        {
          name: "志愿之家",
          linkTo: "/volunteer?index=5&title=志愿之家&curIndex=0",
          children: [
            { name: "志愿者风采", linkTo: "/volunteer" },
            { name: "志愿者服务站", linkTo: "/volunteer/station" },
          ],
        },
        {
          name: "我要捐款",
          linkTo: "/contribution?index=6&title=我要捐款&curIndex=0",
          children: [{ name: "我要捐款", linkTo: "/contribution" }],
        },
      ],
      overlayStyle: {
        width: "110px",
        background: "#ffffff",
        boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.12)",
      },
      navCurrent: "",
      typeOf: "",
      currentM: -1,
    };
  },
  mounted() {
    if (localStorage.getItem("currentIndex") == "undefined") {
      this.current = 0;
    } else {
      this.current = localStorage.getItem("currentIndex");
    }
    console.log(this.current)
  },
  watch: {
    $route(to) {
      this.current = to.query.index;
    },
  },
  methods: {
    go(i, path, name, index) {
      this.$router.push({
        path: path,
        query: {
          index: i,
          title: name,
          curIndex: index,
        },
      });
      this.current = i;
      localStorage.setItem("navCur", index);
    },
    goSelect(i, path) {
      this.current = i;
      this.$router.push({
        path,
        query: {
          i,
        },
      });
    },
  },
};
</script>


<style  lang="scss" scoped>
.head-box {
  width: 100%;
  height: 100px;
  line-height: 100px;
  display: flex;
  box-sizing: border-box;
  z-index: 99;
  .head-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .head-left {
    > img {
      width: 200px;
      height: 48px;
      vertical-align: middle;
    }
  }
  .head-list {
    display: flex;
    cursor: pointer;
    > div:not(:first-child) {
      margin-left: 50px;
      > span {
        font-size: 15px;
        color: #333333;
      }
    }
  }
  .select-box {
    width: 110px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  }
}
.ant-dropdown {
  top: 100px ;
}

.active {
  border-bottom: 3px solid #c1141e;
  padding: 10px 0;
  cursor: pointer;
}

</style>